import useFetch from '@hooks/useFetch';
import { emptyObject } from '@constants/empty';
import { useRouter } from 'next/router';
import { getCompeteInfoKeyForAllMonths } from '@cont/Compete/utils';

const useCompeteInfoForAllMonths = (
  fetchData,
  options = {
    revalidateOnMount: false,
    fallbackData: undefined
  }
) => {
  const { query } = useRouter();
  const key = getCompeteInfoKeyForAllMonths(query.goalUID);

  const { data, isValidating, mutate, ...rest } = useFetch(
    fetchData ? key : null,
    {},
    {
      revalidateOnMount: true,
      fallbackData: options.fallbackData
    }
  );

  return {
    key,
    data: data || emptyObject,
    syllabusForAllMonths: data?.syllabus,
    isValidating,
    mutate,
    ...rest
  };
};

export default useCompeteInfoForAllMonths;
